const getters = {
  usersMsg: state => state.users.msg,
  homeMsg: state => state.home.msg,
  searchInfo: state => state.header.searchInfo,
  // 侧边栏
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  userInfo: state => state.users.userInfo,
  UserHeadPhoto: state => state.users.UserHeadPhoto,
  permission_routes: state => state.permission.routes,
  menuTree: state => state.users.menuTree,
  token: state => state.users.token,
  users: state => state.users.userData,
  chatInfo: state => state.chat.chatInfo
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js